enum ButcherStatus {
    Ready,
    Queued ,
    Live,
    Disabled,
    CoolingDown,
}

export default ButcherStatus;